import CustomerDashboard from '../pages/dashboard/CustomerDashboard';
import EmailDashboard from '../pages/email/dashboard/EmailDashboard';
import { useChannelMode } from '../context/channelModeContext';
import '../pages/email/shared/emailDesign.css';

const CustomerDashboardRoute = () => {
  const { isEmail } = useChannelMode();
  return isEmail ? <EmailDashboard /> : <CustomerDashboard />;
};

export default CustomerDashboardRoute;